import React from 'react';
import ThemeInput from '../inputs/ThemeInput';
import { SearchOutlined } from '@ant-design/icons';
import Assets from '../../constants/images';
import { validation } from '../../constants/appConstants';
import ThemeSelect from '../inputs/ThemeSelect';
import { useSelector } from 'react-redux';
import { getAuthUser } from '../../store/slices/authSlice';
import NotificationPopover from '../ui/molecules/NotificationPopover';

const DashboardHeader = ({
  title,
  welcome = false,
  showSearchbar = true,
  control,
  errors,
  filters,
}) => {
  const authUser = useSelector(getAuthUser);
  const isSuper = authUser?.role_id === 4;

  return (
    <div className="dashboard-header items-center flex relative mb-8">
      <div className="flex flex-col-reverse md:flex-row md:items-center justify-between w-full">
        <div className="w-full relative mt-10 md:mt-0">
          {welcome && <span className="bottom-9 sub-text text-grey absolute ">Welcome</span>}
          <h1 className="heading text-secondary">{title}</h1>
        </div>

        {filters ? (
          <div className={`flex items-center justify-end ${welcome ? 'mb-12' : 'mb-8'} md:mb-0`}>
            {filters.map(({ name, placeholder, options }) => {
              return (
                <div key={name} className="relative -top-3">
                  <ThemeSelect
                    key={name}
                    name={name}
                    control={control}
                    errors={errors}
                    placeholder={placeholder}
                    options={options}
                    className="filter-select me-2"
                  />
                </div>
              );
            })}
          </div>
        ) : null}
        <div
          className={`bg-white flex items-center justify-between p-2 rounded-full gap-3 me-4 ${
            showSearchbar ? 'block' : 'hidden'
          }`}
        >
          {!!control && (
            <>
              <ThemeInput
                name="search"
                control={control}
                errors={errors}
                placeholder="Search"
                type="text"
                maxLength={validation.searchMax}
                className="p-2 px-4 w-full sm:w-72 md:w-64 rounded-full bg-dashboard-bg hover:bg-dashboard-bg border-none "
                prefix={<SearchOutlined className="me-2" />}
              />
            </>
          )}
          <div className="flex items-center justify-center">
            <NotificationPopover />
          </div>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 overflow-hidden rounded-full">
              <img
                className="w-full h-full object-cover object-center"
                src={authUser?.media?.media_thumb_url || Assets.ProfilePlaceholder}
                onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
                alt=""
              />
            </div>
            <span className="whitespace-nowrap text-sm">
              {isSuper ? 'Super Admin' : 'Sub Admin'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
